import React, { FunctionComponent } from "react";
import { MarketplacePage } from "./component";

export const MarketplacePageContainer: FunctionComponent = () => {
  return <MarketplacePage />;
};
